<template>
<div>
  <v-container fluid class="mb-5">
    <v-row justify="start">

        <v-col cols="12" class="d-flex text-left">
        <v-btn color="" class="mygreen white--text mr-6" to="/mail/new">
            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:20px;" />
        メール登録</v-btn>
        </v-col>

    </v-row>
  </v-container>


  <v-data-table
    fixed-header
    :headers="headers"
    :items="records"
    :items-per-page="20"
    sort-by="calories"
    class="elevation-1"
    :height="tableHeight"
    @click:row="rowClick"
  >

    <template v-slot:item.name="{ item }">
        <div v-html="item.name"></div>
    </template>


    <template v-slot:no-data>
    データがありません.
    </template>


  </v-data-table>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogKyukaSearch from '@/components/DialogKyukaSearch.vue';
import DialogKyukaShinsei from '@/components/DialogKyukaShinsei.vue';
import DialogKyukaSasimodosi from '@/components/DialogKyukaSasimodosi.vue';
import DialogKyukaDelete from '@/components/DialogKyukaDelete.vue';
import VueJsonToCsv from 'vue-json-to-csv';
/* eslint-disable */


export default {

  components:{
      DialogKyukaSearch,
      DialogKyukaShinsei,
      DialogKyukaSasimodosi,
      DialogKyukaDelete,
      VueJsonToCsv,
  },

  data(){  // datas
      return {
        modal: false,
        tableHeight: 700,
        dialog: false,
        dialogDelete: false,
        records: [],
        headers: [
          {
            text: '作成日時',
            align: 'start',
            value: 'updated_at',
            width: '15%',
          },
          { text: '送信日時', value: 'yoyaku_date',
            width: '15%',
          },
          { text: '患者名', value: 'name' },
          { text: 'メールアドレス', value: 'mail' },
          { text: 'テンプレート名', value: 'template_name' },
          { text: '送信ステータス', value: 'status' },
        ],
        editedIndex: -1,
        editedItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        defaultItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
      }
  },
  computed: {
    ...mapGetters(['user', 'user_name', 'is_admin']),
  },

  watch: {
  },

  created () {
      console.log('%c created: MailList.vue', mycolor.created);
      this.initialize();
  },

  mounted () {
    console.log('mounted');
  },

  methods: {

      rowClick(v){
          console.log('rowClick');
          console.log(v);
          this.$router.push('/mail/'+v.id).catch(()=>{});
          return false;
      },



    // 初期化
    initialize () {


      axios.get('/get_mail')
        .then((res) => {
          console.group();
          console.log('%c /get_mail', mycolor.api);
          console.log(res.data);
          console.groupEnd();
          this.records = res.data;

        })
        .catch(() => {
          // eslint-disable-next-line
          console.error();
        });

    },
  },  // methods
}  // export default
</script>

<style scoped>
/deep/ .kana{
    font-size: 9px;
}
/deep/ .myred{
    color: red;
}
</style>
